import React, { useState } from "react";
import { Form, Button, Spinner, Alert } from "react-bootstrap";
import { updateUserPreferences } from "../../api";
import { getUserPreferences } from "./userPreferences";

// Shared preference controls used by both the BootNav Settings modal and
// the User Profile page's Preferences card. Owns its own local state so each
// mount reads the current JWT-backed prefs and stages edits in place; on Save
// we POST to /users/me/preferences (which re-signs the JWT into sessionStorage)
// then call onSaved so the parent can close the modal / refresh user data.
export default function PreferencesPanel({ onSaved }) {
  const initial = getUserPreferences();
  const [autoConfirm, setAutoConfirm] = useState(
    !!initial.autoConfirmAppointments,
  );
  const [autoComplete, setAutoComplete] = useState(
    !!initial.autoCompleteAppointments,
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    setSaving(true);
    setError("");
    const res = await updateUserPreferences({
      autoConfirmAppointments: autoConfirm,
      autoCompleteAppointments: autoComplete,
    });
    setSaving(false);
    if (!res.success) {
      setError(res.error || "Could not save preferences.");
      return;
    }
    onSaved?.();
  };

  return (
    <div>
      {error && (
        <Alert variant="danger" className="py-2">
          {error}
        </Alert>
      )}

      <Form.Check
        type="switch"
        id="pref-auto-confirm-appointments"
        className="mb-1"
        label="Auto-confirm appointments"
        checked={autoConfirm}
        onChange={(e) => setAutoConfirm(e.target.checked)}
        disabled={saving}
      />
      <div className="text-muted small mb-3 ms-4">
        When enabled, "Send Confirmation Email" is pre-checked on new appointments. Editing an existing appointment never auto-checks it.
      </div>

      <Form.Check
        type="switch"
        id="pref-auto-complete-appointments"
        className="mb-1"
        label="Auto-complete appointments"
        checked={autoComplete}
        onChange={(e) => setAutoComplete(e.target.checked)}
        disabled={saving}
      />
      <div className="text-muted small mb-3 ms-4">
        When enabled, "Complete appointment" is pre-checked when saving session notes.
      </div>

      <div className="d-flex justify-content-end">
        <Button variant="primary" onClick={handleSave} disabled={saving}>
          {saving ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Saving…
            </>
          ) : (
            "Save"
          )}
        </Button>
      </div>
    </div>
  );
}
